import Loader from 'components/loader/Loader';
import EmptyRecordingList from './EmptyRecordingList';
import RecordingList from './RecordingList';

export default function ContentSecion({ loading, isEmpty, filter, sortedRecordings }) {
    if (loading) return <Loader />
    if (isEmpty) return <EmptyRecordingList filter={filter} />
    return <RecordingList sortedRecordings={sortedRecordings} />
}
